import * as React from 'react'

const getOverlaySidePosition = ({
  container,
  target
}: {
  container: HTMLElement
  target: HTMLElement
}) => {
  let top
  let left

  const documentWidth =
    document.body.offsetWidth ||
    (document.documentElement && document.documentElement.offsetWidth) ||
    0
  const containerViewportPosition = container.getBoundingClientRect()

  top = target.offsetHeight - container.offsetHeight
  left = target.offsetWidth

  // Adjust top if exceeds viewport at the top
  if (Math.abs(top) > containerViewportPosition.top) {
    top = -containerViewportPosition.top
  }

  // Display container on the left side of the target if it exceeds viewport on the right side
  if (target.offsetWidth + containerViewportPosition.right > documentWidth) {
    left = -container.offsetWidth
  }

  return {
    left,
    top
  }
}

type PostionFunction = ({
  container,
  target
}: {
  container: HTMLElement
  target: HTMLElement
}) => {
  left: number
  top: number
}

interface IPositionStrategies {
  side: PostionFunction
  [key: string]: PostionFunction
}

const PositionStrategies: IPositionStrategies = {
  side: getOverlaySidePosition
}

interface IProps {
  content: any
  position: string | PostionFunction
}

interface IState {
  showContent: boolean
}

class Overlay extends React.Component<IProps, IState> {
  public static defaultProps = {
    position: 'side'
  }

  public state: IState = {
    showContent: false
  }

  private timeoutId: number
  private $content: HTMLDivElement | null
  private $target: HTMLDivElement | null

  public componentDidUpdate() {
    if (this.state.showContent && this.$target && this.$content) {
      const position = this.getOverlayPosition(this.$content, this.$target)
      this.$content.style.left = `${position.left}px`
      this.$content.style.top = `${position.top}px`
    }
  }

  public render() {
    return (
      <div style={{ position: 'relative' }}>
        {this.state.showContent && this.renderContent()}
        <div
          ref={$target => {
            this.$target = $target
          }}
          style={{ display: 'inline-block' }}
          onMouseEnter={this.onMouseEnter.bind(this)}
          onMouseLeave={this.onMouseLeave.bind(this)}
        >
          {this.props.children}
        </div>
      </div>
    )
  }

  private onMouseEnter() {
    this.timeoutId = window.setTimeout(() => {
      this.setState({
        showContent: true
      })
    }, 500)
  }

  private onMouseLeave() {
    clearTimeout(this.timeoutId)
    this.setState({ showContent: false })
  }

  private renderContent() {
    return (
      <div
        ref={$content => {
          this.$content = $content
        }}
        style={{ display: 'inline-block', position: 'absolute' }}
      >
        {this.props.content}
      </div>
    )
  }

  private getOverlayPosition(container: HTMLElement, target: HTMLElement) {
    if (typeof this.props.position === 'function') {
      return this.props.position({ container, target })
    }
    return PositionStrategies[this.props.position]({ container, target })
  }
}

export default Overlay
